import React, { useState } from 'react';
import { X, CheckCircle, XCircle, Eye } from 'lucide-react';

const ApproveRequestModal = ({ 
  isOpen, 
  onClose, 
  request, 
  onApprove, 
  onReject,
  isSubmitting = false,
  actionType = 'approve' // 'approve' or 'reject'
}) => {

  if (!isOpen || !request) return null;

  const getActionIcon = (actionType) => {
    switch (actionType) {
      case 'create':
        return <CheckCircle className="h-5 w-5 text-green-600" />;
      case 'create_role':
        return <CheckCircle className="h-5 w-5 text-green-600" />;
      case 'create_sub_account':
        return <CheckCircle className="h-5 w-5 text-green-600" />;
      case 'activate':
        return <CheckCircle className="h-5 w-5 text-green-600" />;
      case 'deactivate':
        return <XCircle className="h-5 w-5 text-red-600" />;
      case 'delete':
        return <XCircle className="h-5 w-5 text-red-600" />;
      default:
        return <CheckCircle className="h-5 w-5 text-green-600" />;
    }
  };

  const getActionTitle = (actionType) => {
    switch (actionType) {
      case 'create':
        return 'Create User';
      case 'create_role':
        return 'Create Role';
      case 'create_sub_account':
        return 'Create Sub Account';
      case 'activate':
        return 'Activate User';
      case 'deactivate':
        return 'Deactivate User';
      case 'delete':
        return 'Delete User';
      default:
        return 'User Action';
    }
  };

  const getTargetName = (request) => {
    if (request.targetData?.name) {
      return request.targetData.name;
    }
    if (request.targetData?.email) {
      return request.targetData.email;
    }
    if (request.targetData?.personalInfo?.firstName && request.targetData?.personalInfo?.lastName) {
      return `${request.targetData.personalInfo.firstName} ${request.targetData.personalInfo.lastName}`;
    }
    if (request.targetData?.corporateInfo?.companyName) {
      return request.targetData.corporateInfo.companyName;
    }
    return 'N/A';
  };

  const handleApprove = () => {
    onApprove(request._id);
    onClose();
  };

  const handleReject = () => {
    onReject(request._id);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            {getActionIcon(request.actionType)}
            <h2 className="text-lg font-semibold text-gray-900">
              Approve Request
            </h2>
          </div>
          <button
            onClick={onClose}
            disabled={isSubmitting}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="space-y-4">
            <div>
              <span className="font-semibold text-gray-900">Action:</span>
              <span className="ml-2 text-gray-700">{getActionTitle(request.actionType)}</span>
            </div>
            
            <div>
              <span className="font-semibold text-gray-900">
                {request.actionType === 'create_role' ? 'Role:' : 
                 request.actionType === 'create_sub_account' ? 'Sub Account:' : 'User:'}
              </span>
              <span className="ml-2 text-gray-700">{getTargetName(request)}</span>
            </div>
            
            <div>
              <span className="font-semibold text-gray-900">Requested by:</span>
              <span className="ml-2 text-gray-700">{request.initiatorId?.email || 'N/A'}</span>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-3 pt-6">
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              className="btn-secondary"
            >
              Cancel
            </button>
            
            {actionType === 'approve' ? (
              <button
                type="button"
                onClick={handleApprove}
                disabled={isSubmitting}
                className="btn-primary"
              >
               
                Approve
              </button>
            ) : (
              <button
                type="button"
                onClick={handleReject}
                disabled={isSubmitting}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-50"
              >
               
                Reject
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApproveRequestModal;
